<div #destination class="searchPlaceInput__cont">
  <div class="searchPlaceInput__input" [class.results]="isResultsPage" [class.package-detail]="isHotelDetailPackageDesktop" [class.tour-and-activities]="searchTourAndActivities">
    <app-ds-input-text
      [isReadonly]="true"
      [isDisabled]="isDisabled"
      [icon]="icon"
      [size]="inputSize"
      [filled]="filled"
      [staticFilled]="staticFilled"
      [label]="countryCode"
      [placeholder]="countryCode"
      [value]="
      (isResultsPage ? ((defaultCityName || countryCode) + ', ') : '') +
      (
        isMobile ? (
        defaultCountryMobile ?
          defaultCountryMobile + (defaultCityCode ? (' (' + defaultCityCode + ')') : '') :
            ''
        ) : (
          isResultsPage ?
            (defaultCountryName || countryName) :
              (defaultCountry || countryCode)
        )
      )"
      [isFailed]="showError"
      [failedMessage]="samePlaceError ? (sameDestinationMessage | transloco) : (emptyInputErrorMessage | transloco)"
      (clickEvent)="toggleInput()">
    </app-ds-input-text>
  </div>
  <div class="searchPlaceInput__autocomplete">
    <app-search-input-autocomplete
      [searchType]="searchType"
      [placeType]="placeType"
      [query]="query"
      [isMobile]="isMobile"
      [viewAutocomplete]="showInput"
      [inputPlaceListIcon]="icon"
      [inputPlaceListLabel]="countryCode"
      [title]="countryCode"
      [inputPlaceListPlaceholder]="'SEARCH_MODULE.LOCATION_SEARCH.YOUR_DESTINATION' | transloco"
      [isLoadingAutocompletePlaces]="isLoadingAutocompletePlaces"
      [cityAndAirportsAutocomplete]="resultsPlaces"
      [airportsAreEnabled]="mergeAirportsAndCities"
      [mergeAirportsAndCities]="mergeAirportsAndCities"
      [useIconInSubdirectories]="false"
      (closeAutocomplete)="toggleInput()"
      (setQuery)="setQuery($event)"
      (selectPopularPlace)="emitSelectPlace($event)"
      (selectAirportOrCityEvent)="selectAirportOrCity($event)"
      (popularSelected)="popularSelected.emit($event)">
    </app-search-input-autocomplete>
  </div>
</div>
